var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftcomponent = function SvgArrowLeftcomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 13.727C5.229 14.164 8.957 17.66 9.257 24l3.986-.874c-.514-4.46-3.429-8.35-6.814-9.4H30v-3.41H6.429c3.385-1.048 6.3-4.983 6.814-9.398L9.257 0C8.957 6.339 5.23 9.88 0 10.317z"
  })));
};
export default SvgArrowLeftcomponent;